import { ScheduleTaskAttributeBase } from './base/schedule-task-attribute-base';

export class ScheduleTaskAttribute extends ScheduleTaskAttributeBase { }